import { IWebhook, IWebhookComSegredo, IWebhookEvento, IWebhookSalvar, IWebhookTeste } from "../interfaces/IWebhook";
import api from "./Api";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3';

// O interceptor do Api já troca o erro por { message } com a mensagem do backend.
function erro(error: any, timer = 5000) {
  Swal.fire({ text: error.message, timer, icon: 'error', showConfirmButton: false });
}

// DEVN3-631: webhook da API pública pelo painel (Administrador e Master). clienteId só tem efeito
// para Master; o Administrador sempre trabalha no próprio cliente.
class WebhookService {

  // null = cliente sem webhook (204).
  async obter(clienteId?: number): Promise<IWebhook | null> {
    try {
      const resposta = await api.get<IWebhook>('webhook', { baseURL: BASE_URL, params: clienteId ? { clienteId } : undefined });
      return resposta.status === 204 || !resposta.data ? null : resposta.data;
    } catch (error: any) {
      erro(error);
      return null;
    }
  }

  // Na criação a resposta traz o segredo — não guardar fora da memória da tela.
  async salvar(dados: IWebhookSalvar): Promise<IWebhook | IWebhookComSegredo | null> {
    try {
      const { data } = await api.put<IWebhook | IWebhookComSegredo>('webhook', dados, { baseURL: BASE_URL });
      return data;
    } catch (error: any) {
      erro(error, 6000);
      return null;
    }
  }

  async regerarSegredo(clienteId?: number): Promise<IWebhookComSegredo | null> {
    try {
      const { data } = await api.post<IWebhookComSegredo>('webhook/regerar-segredo', null,
        { baseURL: BASE_URL, params: clienteId ? { clienteId } : undefined });
      return data;
    } catch (error: any) {
      erro(error);
      return null;
    }
  }

  async remover(clienteId?: number): Promise<boolean> {
    try {
      await api.delete('webhook', { baseURL: BASE_URL, params: clienteId ? { clienteId } : undefined });
      return true;
    } catch (error: any) {
      erro(error);
      return false;
    }
  }

  async enviarTeste(clienteId?: number): Promise<IWebhookTeste | null> {
    try {
      const { data } = await api.post<IWebhookTeste>('webhook/teste', null,
        { baseURL: BASE_URL, params: clienteId ? { clienteId } : undefined });
      return data;
    } catch (error: any) {
      erro(error);
      return null;
    }
  }

  // DEVN3-636: filtros opcionais de período (YYYY-MM-DD) e situação.
  async listarEntregas(clienteId?: number, filtros?: { de?: string; ate?: string; situacao?: string }): Promise<IWebhookEvento[]> {
    try {
      const params = Object.fromEntries(Object.entries({ clienteId, ...filtros }).filter(([, v]) => v !== undefined && v !== ''));
      const { data } = await api.get<IWebhookEvento[]>('webhook/entregas', { baseURL: BASE_URL, params });
      return data;
    } catch (error: any) {
      erro(error);
      return [];
    }
  }

  // DEVN3-636: reenvio manual de uma entrega que falhou ou foi cancelada (uma tentativa, na hora).
  async reenviar(eventoId: string, clienteId?: number): Promise<IWebhookTeste | null> {
    try {
      const { data } = await api.post<IWebhookTeste>(`webhook/entregas/${encodeURIComponent(eventoId)}/reenviar`, null,
        { baseURL: BASE_URL, params: clienteId ? { clienteId } : undefined });
      return data;
    } catch (error: any) {
      erro(error);
      return null;
    }
  }
}

export default new WebhookService();
